export default __webpack_public_path__ + "static/beneficios-ciudadanos-21ef59d7804d564847c2d2442e9da61b.png";